const SimpleTable = ({ data }) => {
    const SimpleTable = ({ data, loading }) => {
        if (loading) return <p className="p-4 text-blue-500">Loading...</p>;
        if (!data || data.length === 0)
            return <p className="p-4 text-gray-500">No data available</p>;

        // ... rest of your table
    };


    return (
        <div className="p-4">
            <table className="min-w-full border border-blue-800 bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-[#267CB8] text-white">
                    <tr>
                        <th className="px-4 py-2 text-left">Retro Code</th>
                        <th className="px-4 py-2 text-left">Description</th>
                        <th className="px-4 py-2 text-left">Chassis No</th>
                        <th className="px-4 py-2 text-left">Vehicle Reg No</th>
                        <th className="px-4 py-2 text-left">Pending Count</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, i) => (
                        <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-blue-50"}>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.Retro_Code}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.Retro_Code_Desc}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.Chassis_No}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.Vehicle_Registration_No}
                            </td>
                            <td className="px-4 py-2 border-t border-blue-200">
                                {item.Pending_Count}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
export default SimpleTable